import React from 'react';

import Util, { Data } from 'service/util';
import moment from 'moment';

const today = moment().startOf('day');
let dict_company;

class VehicleCard extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = props.model;
  }

  render()
  {
    if (!dict_company) {
      dict_company = Data.company.reduce((r,x) => {
        r[x.cd] = x.name;
        return r;
      }, {});
    }
    let a = this.state.activeService
          || this.state.services.filter(s => moment(s.start_dtm).isAfter(today))[0];
    return (
      <div className="vehicle">
        <span className="tag license" onClick={this.props.onClick}>
          <span className={'p '+(a?.srv_plan||'no-service')}>
            { a ? `${a.srv_plan}${this.state.vh_type}` : '停' }
          </span>
          { !a?'': <span className="vh-srv-company">{ dict_company[a.company] }</span> }
          <span className="vh-license">{ this.state.cd_license }</span>
        </span>
        {!a?'':<>
          <div>
            <span>${ Util.nf2( a.fee ) }</span>
            {
              !a.end_dtm?''
              :<span> (至 {Util.ShortDate(a.end_dtm)})</span>
            }
          </div>
          <div>{a.srv_dis}{a.srv_loc} - {a.loc_name}</div>
          <div>{[a.srv_floor, a.srv_psn].join(', ').trim()}</div>
          <div className="service-weekday">
            <span>{ Util.WeekdayName(a.weekday1) }</span>
            <span>{ Util.WeekdayName(a.weekday2) }</span>
            <span>{ Util.WeekdayName(a.weekday3) }</span>
          </div>
        </>}
      </div>
    );
  }
}

export default VehicleCard;